function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
import React from 'react';
import PropTypes from 'prop-types';
import { SearchResult as SearchResultSemantic } from 'semantic-ui-react';

// Note: You technically only need the 'content' wrapper when there's an
// image. However, optionally wrapping it makes this function a lot more
// complicated and harder to read. Since always wrapping it doesn't affect
// the style in any way let's just do that.
//
// Note: To avoid requiring a wrapping div, we return an array here so to
// prevent rendering issues each node needs a unique key.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultRenderer = function defaultRenderer(_ref) {
  var image = _ref.image,
    price = _ref.price,
    title = _ref.title,
    description = _ref.description;
  return [image && /*#__PURE__*/_jsx("div", {
    className: "image",
    children: /*#__PURE__*/_jsx("img", {
      src: image,
      alt: title
    })
  }, "image"), /*#__PURE__*/_jsxs("div", {
    className: "content",
    children: [price && /*#__PURE__*/_jsx("div", {
      className: "price",
      children: price
    }), title && /*#__PURE__*/_jsx("div", {
      className: "title",
      children: title
    }), description && /*#__PURE__*/_jsx("div", {
      className: "description",
      children: description
    })]
  }, "content")];
};

/**
 *
 * @param {*} props
 */
defaultRenderer.handledProps = [];
var SearchResult = function SearchResult(props) {
  var rest = Object.assign({}, (_objectDestructuringEmpty(props), props));
  return /*#__PURE__*/_jsx(SearchResultSemantic, Object.assign({}, rest));
};
SearchResult.handledProps = ["active", "as", "className", "content", "description", "id", "image", "onClick", "price", "renderer", "title"];
SearchResult.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  /** The item currently selected by keyboard shortcut. */
  active: PropTypes.bool,
  /** Additional classes. */
  className: PropTypes.string,
  /** Shorthand for primary content. */
  content: PropTypes.node,
  /** Additional text with less emphasis. */
  description: PropTypes.string,
  /** A unique identifier. */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Add an image to the item. */
  image: PropTypes.string,
  /**
     * Called on click.
     *
     * @param {SyntheticEvent} event - React's original SyntheticEvent.
     * @param {object} data - All props.
     */
  onClick: PropTypes.func,
  /** Customized text for price. */
  price: PropTypes.string,
  /**
     * Renders the result contents.
     *
     * @param {object} props - The SearchResult props object.
     * @returns {*} - Renderable result contents.
     */
  renderer: PropTypes.func,
  /** Display title. */
  title: PropTypes.string.isRequired
};
SearchResult.defaultProps = {
  renderer: defaultRenderer
};
export default SearchResult;